import defaultMethods from "../../handlers/nested/utils";
import { BaseNestedHandler } from "../../handlers/nested/base";
export { BaseNestedHandler } from "../../handlers/nested/base";
/**
 * `NestedArrayHandler` is a base class for handling arrays of objects on an api handler (promise | observable).
 * This provides a solution for handling nested changes and validations.
 * It extends the {@link BaseNestedHandler} class and implements methods to find, delete, and merge changes for nested items.
 * @category Nested Handlers
 * @template ParentHandler The parent handler type, which extends {@link AnyApiHandler}.
 * @template KeyPath The key path type for the nested items, which is a path in the parent handler's data structure.
 * @template Validators The type of validators to apply, which can be a set of validation methods or never if no validation is needed.
 * @template FilterType The type of filter to apply when searching for nested items, defaulting to an object with an `id` property.
 * @template Parent The type of the parent object, derived from the parent handler.
 * @template Item The type of the nested item, which is inferred from the parent handler's data structure based on the provided key path.
 */
export class NestedArrayHandler extends BaseNestedHandler {
    /**
     * Default find logic for nested arrays.
     * If extending class does not override, this will be used.
     * `findItems` is used for {@link BaseNestedHandler.find} and {@link BaseNestedHandler.find_once}
     */
    findItems(parent, filters) {
        return defaultMethods.array.findItems(parent, filters, this);
    }
    /**
     * Default delete logic for nested arrays.
     * If extending class does not override, this will be used.
     * `deleteItems` is used for {@link BaseNestedHandler.delete}
     */
    deleteItems(parent, identifiers) {
        return defaultMethods.array.deleteItems(parent, identifiers, this);
    }
    /**
     * Default merging changes logic for nested arrays.
     * If extending class does not override, this will be used.
     * `mergeChanges` is used for {@link BaseNestedHandler.merge}
     */
    mergeChanges(parent, child) {
        return defaultMethods.array.mergeChanges(parent, child, this);
    }
}
//# sourceMappingURL=index.js.map